import {appLocalStorage, appSessionStorage} from '../services';

const initialState = () => {
  return {
    currentStep: 1,
    showLoginForm: false,
    isBusinessAccount: false,
    customerEmail: appLocalStorage.getItem('checkout-customer-email', ''),
    extensionAttributes: appLocalStorage.getItem('checkout-extension-attributes', {}),
    newsletterSubscribe: appLocalStorage.getItem('checkout-newsletter-subscription', true),
    orderComment: appLocalStorage.getItem('checkout-order-comment', ''),
  };
};

const getters = {
  currentStep: (state) => state.currentStep,
  customerEmail: (state) => state.customerEmail,
  isBusinessAccount: (state) => state.isBusinessAccount,
  showLoginForm: (state) => state.showLoginForm,
  getExtensionAttributes: (state) => state.extensionAttributes,
};

const mutations = {
  TOGGLE_LOGIN_FORM(state) {
    state.showLoginForm = !state.showLoginForm;
  },
  SET_CURRENT_STEP(state, currentStep) {
    state.currentStep = currentStep;
  },
  SET_CUSTOMER_EMAIL(state, customerEmail) {
    const normalizedCustomerEmail = customerEmail || '';
    state.customerEmail = normalizedCustomerEmail;
    appLocalStorage.setItem('checkout-customer-email', normalizedCustomerEmail);
  },
  SET_IS_BUSINESS_ACCOUNT(state, isBusinessAccount) {
    state.isBusinessAccount = isBusinessAccount;
    appLocalStorage.setItem('customer-is-b2b', isBusinessAccount);
  },
  SET_NEWSLETTER_SUBSCRIBE(state, status) {
    state.newsletterSubscribe = status;
    appLocalStorage.setItem('checkout-newsletter-subscription', status);
  },
  SET_ORDER_COMMENT(state, comment) {
    state.orderComment = comment || '';
    appLocalStorage.setItem('checkout-order-comment', state.orderComment);
  },
  ADD_EXTENSION_ATTRIBUTE(state, extensionAttribute) {
    state.extensionAttributes = {
      ...state.extensionAttributes,
      ...extensionAttribute,
    };
    appLocalStorage.setItem('checkout-extension-attributes', state.extensionAttributes);
  },
  REMOVE_EXTENSION_ATTRIBUTE(state, extensionAttribute) {
    if (state.extensionAttributes.hasOwnProperty(extensionAttribute)) {
      delete state.extensionAttributes[extensionAttribute];
    }
    appLocalStorage.setItem('checkout-extension-attributes', state.extensionAttributes);
  },
  CLEAR_EXTENSION_ATTRIBUTE(state) {
    state.extensionAttributes = {};
    appLocalStorage.removeItem('checkout-extension-attributes');
  },
};

const actions = {
  async checkCustomerEmail({ state, commit, rootState }, customerEmail) {
    try {
      return await this.$solarClient.post(`/api/checkout/customers/isEmailAvailable`, {
        customerEmail: customerEmail,
      });
    } catch (e) {
      return false;
    }
  },
  async addExtensionAttribute({ commit }, extensionAttribute) {
    commit('ADD_EXTENSION_ATTRIBUTE', extensionAttribute);
  },
  async gotoStep({ commit }, step) {
    commit('SET_CURRENT_STEP', step);
  },
  async setNewsletterSubscribe({ commit }, status) {
    commit('SET_NEWSLETTER_SUBSCRIBE', status);
  },
  setOrderComment({ commit }, comment) {
    commit('SET_ORDER_COMMENT', comment);
  },
  toggleLoginForm({ commit }) {
    commit('TOGGLE_LOGIN_FORM');
  },
};

const state = initialState();

const CheckoutGlobal = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default CheckoutGlobal;
